import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Alert,
} from "reactstrap";
import axios from "axios";
import swal from "sweetalert";
import { API_DONOR_DARAH, API_TIMEOUT } from "utils";

function ResponsePermintaanForm() {
  const location = useLocation();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [donaturData, setDonaturData] = useState(null);
  const [donorData, setDonorData] = useState(null);
  const [permintaanData, setPermintaanData] = useState(null);
  const [formData, setFormData] = useState({
    tanggal: "",
    jumlah: "",
    status: "bersedia",
  });

  // Ambil parameter dari URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const donaturId = params.get("donaturId");
    const requestId = params.get("requestId");

    if (!donaturId || !requestId) {
      swal("Error", "Parameter tidak lengkap", "error").then(() => {
        window.location.href = "/#/login";
      });
      return;
    }

    // Ambil data donatur dan permintaan
    fetchData(donaturId, requestId);
  }, [location]);

  const fetchData = async (donaturId, requestId) => {
    try {
      // Ambil data donatur
      const donaturResponse = await axios.get(
        `${API_DONOR_DARAH}donatur/${donaturId}`,
        { timeout: API_TIMEOUT }
      );

      // Ambil data permintaan
      const permintaanResponse = await axios.get(
        `${API_DONOR_DARAH}donationrequests/${requestId}`,
        { timeout: API_TIMEOUT }
      );

      if (donaturResponse.data?.success && donaturResponse.data.data) {
        setDonaturData(donaturResponse.data.data);
        setDonorData(donaturResponse.data.data); // Set donorData juga
      }

      if (permintaanResponse.data?.success && permintaanResponse.data.data) {
        setPermintaanData(permintaanResponse.data.data);
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      swal("Error", "Gagal mengambil data", "error").then(() => {
        window.location.href = "/#/login";
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.tanggal || !formData.jumlah) {
      swal("Info", "Tanggal dan jumlah harus diisi", "error");
      return;
    }

    setSubmitting(true);

    const params = new URLSearchParams(location.search);
    const donaturId = params.get("donaturId");
    const requestId = params.get("requestId");

    // Validasi parameter
    if (!donaturId || !requestId) {
      swal("Error", "Parameter tidak lengkap", "error");
      setSubmitting(false);
      return;
    }

    // Gunakan donaturData jika donorData belum tersedia
    const donorInfo = donorData || donaturData;

    if (!donorInfo) {
      swal("Error", "Data donor tidak ditemukan", "error");
      setSubmitting(false);
      return;
    }

    const data = {
      requestID: requestId,
      pendonorID: donaturId, // Backend expects pendonorID, not donaturID
      tanggal: formData.tanggal,
      catatan: formData.status || "",
      nama: donorInfo.nama || "",
      noHp: donorInfo.noHp || "",
    };

    try {
      const response = await axios.post(
        `${API_DONOR_DARAH}responpendonor`,
        data,
        { timeout: API_TIMEOUT }
      );

      if (response.data?.success) {
        swal("Berhasil", "Response berhasil dikirim", "success").then(() => {
          window.location.href = "/#/login";
        });
      } else {
        swal("Gagal", "Response gagal dikirim", "error");
      }
    } catch (error) {
      console.error("Error submitting response:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Response gagal dikirim";
      swal("Gagal", errorMessage, "error");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="content" style={{ padding: "50px" }}>
        <div className="text-center">
          <h4>Memuat data...</h4>
        </div>
      </div>
    );
  }

  return (
    <div
      className="content"
      style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}
    >
      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <h4 className="title">Form Response Permintaan Darah</h4>
            </CardHeader>
            <CardBody>
              {donaturData && (
                <Alert color="info">
                  <strong>Data Pendonor:</strong>
                  <br />
                  Nama: {donaturData.nama}
                  <br />
                  Golongan Darah: {donaturData.bloodTypes}
                  <br />
                  No. HP: {donaturData.noHp}
                </Alert>
              )}

              {permintaanData && (
                <Alert color="primary">
                  <strong>Detail Permintaan:</strong>
                  <br />
                  Untuk: {permintaanData.namaPenerima}
                  <br />
                  Golongan Darah: {permintaanData.golonganDarah}
                  <br />
                  Jumlah Dibutuhkan: {permintaanData.jumlahDibutuhkan} kantong
                  <br />
                  Tanggal Permintaan:{" "}
                  {new Date(
                    permintaanData.tanggalPermintaan
                  ).toLocaleDateString("id-ID")}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <FormGroup>
                  <Label>Tanggal Donor</Label>
                  <Input
                    type="date"
                    value={formData.tanggal}
                    onChange={(e) =>
                      setFormData({ ...formData, tanggal: e.target.value })
                    }
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Jumlah Kantong</Label>
                  <Input
                    type="number"
                    min="1"
                    value={formData.jumlah}
                    onChange={(e) =>
                      setFormData({ ...formData, jumlah: e.target.value })
                    }
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Status</Label>
                  <Input
                    type="select"
                    value={formData.status}
                    onChange={(e) =>
                      setFormData({ ...formData, status: e.target.value })
                    }
                  >
                    <option value="bersedia">Bersedia</option>
                    <option value="tidak_bersedia">Tidak Bersedia</option>
                  </Input>
                </FormGroup>

                <CardFooter>
                  <Button
                    type="submit"
                    color="primary"
                    disabled={submitting}
                    style={{ marginRight: "10px" }}
                  >
                    {submitting ? "Mengirim..." : "Kirim Response"}
                  </Button>
                  <Button
                    type="button"
                    color="secondary"
                    onClick={() => (window.location.href = "/#/login")}
                  >
                    Batal
                  </Button>
                </CardFooter>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default ResponsePermintaanForm;
